import { SharedProps } from '@/types'
import { Head, usePage } from '@inertiajs/react'
import { Button, Group, Modal, Stack, Title } from '@mantine/core'
import { IconPlus } from '@tabler/icons-react'
import { ReactNode, useEffect } from 'react'

export default function ComptoirShell({
  title,
  opened,
  onOpen,
  onClose,
  showNewOrderButton = true,
  modalChildren,
  children,
}: {
  title: string
  opened: boolean
  onOpen: () => void
  onClose: () => void
  showNewOrderButton?: boolean
  modalChildren: ReactNode
  children: ReactNode
}) {
  const { current_organization } = usePage<SharedProps>().props

  useEffect(() => {
    if (window.location.hash === '#new-order') onOpen()
  }, [])

  return (
    <Stack>
      <Head title={`${title} - ${current_organization!.name}`} />

      <Group justify="space-between" align="center">
        <Title>{title}</Title>

        {showNewOrderButton && (
          <Button leftSection={<IconPlus size={18} />} onClick={onOpen}>
            Nouvelle commande
          </Button>
        )}

        <Modal opened={opened} onClose={onClose} title="Créer une commande" centered>
          <Stack>{modalChildren}</Stack>
        </Modal>
      </Group>

      {children}
    </Stack>
  )
}
